/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PolicyDetailModel } from './PolicyDetailModel';
import {
    PolicyDetailModelFromJSON,
    PolicyDetailModelFromJSONTyped,
    PolicyDetailModelToJSON,
    PolicyDetailModelToJSONTyped,
} from './PolicyDetailModel';

/**
 * 
 * @export
 * @interface GroupServiceGetResponse
 */
export interface GroupServiceGetResponse {
    /**
     * 
     * @type {PolicyDetailModel}
     * @memberof GroupServiceGetResponse
     */
    policyDetailModel?: PolicyDetailModel;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceGetResponse
     */
    requestStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceGetResponse
     */
    requestedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceGetResponse
     */
    requestedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceGetResponse
     */
    assignedTo?: string | null;
}

/**
 * Check if a given object implements the GroupServiceGetResponse interface.
 */
export function instanceOfGroupServiceGetResponse(value: object): value is GroupServiceGetResponse {
    return true;
}

export function GroupServiceGetResponseFromJSON(json: any): GroupServiceGetResponse {
    return GroupServiceGetResponseFromJSONTyped(json, false);
}

export function GroupServiceGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupServiceGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'policyDetailModel': json['policyDetailModel'] == null ? undefined : PolicyDetailModelFromJSON(json['policyDetailModel']),
        'requestStatus': json['requestStatus'] == null ? undefined : json['requestStatus'],
        'requestedBy': json['requestedBy'] == null ? undefined : json['requestedBy'],
        'requestedDate': json['requestedDate'] == null ? undefined : (new Date(json['requestedDate'])),
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
    };
}

export function GroupServiceGetResponseToJSON(json: any): GroupServiceGetResponse {
    return GroupServiceGetResponseToJSONTyped(json, false);
}

export function GroupServiceGetResponseToJSONTyped(value?: GroupServiceGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policyDetailModel': PolicyDetailModelToJSON(value['policyDetailModel']),
        'requestStatus': value['requestStatus'],
        'requestedBy': value['requestedBy'],
        'requestedDate': value['requestedDate'] == null ? undefined : ((value['requestedDate']).toISOString()),
        'assignedTo': value['assignedTo'],
    };
}

